import type { SVGProps } from 'react'

// Solid alert-circle — filled disc with an exclamation-mark cutout.
// Used by TextArea's error-state hint icon. Matches Figma's
// `alert-circle-solid` glyph (Catalyst node `161:5544`) referenced from
// node `1813:45194` (Delegate confirm with required-field error).
//
// Implemented as a single `fillRule="evenodd"` path so the bar + dot
// cutouts show whatever's behind the icon (no hardcoded white fill).
// `currentColor` paints the disc — inherits from `.errorIconWrap`
// (which is bound to `--colors-text-error-primary` per Figma).

export default function AlertCircleSolid(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-14a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm0 9.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
    </svg>
  )
}
